import { Controller } from "@hotwired/stimulus"

// A dialog the server sends back after a failed save opens itself with its errors; closing it drops them, so the next open starts clean.
export default class extends Controller {
  static values = { open: Boolean }

  connect() {
    this.clearErrors = () => this.element.querySelectorAll("[data-form-errors]").forEach((el) => el.remove())
    this.element.addEventListener("close", this.clearErrors)
    if (this.openValue && !this.element.open) this.element.showModal?.()
  }

  disconnect() {
    this.element.removeEventListener("close", this.clearErrors)
  }
}
